// extracted by mini-css-extract-plugin
export default {"accessories__container":"AccessoriesPage_accessories__container__VyJ+b"};